import { CheckmarkCircle03Icon } from '@hugeicons/react'

/* Estado "check-in feito" do perfil do parceiro. Ocupa o mesmo slot do CTA
   (`Button variant="primary" size="lg"`) — mesma altura e mesmo raio, pelos
   tokens `--control-*` de §4 do MASTER —, então a troca de estado não move o
   conteúdo abaixo dela.

   Não é `Badge` nem `.badge`: aquele contrato é pílula de 20–22px com
   `width: fit-content` e rótulo em CAIXA ALTA de 10px. A versão anterior
   esticava `.badge-success` para `h-[30px] w-full`, o que rendia a barra com
   um rótulo de 10px perdido no meio. Aqui o rótulo é corpo (16px, piso do
   ACCESSIBILITY §2) porque é o texto da tela, não um chip subordinado a um
   título.

   Tinta: o par de tint de sucesso já resolvido no DS —
   `--color-success-light` de fundo e `--color-success-text` de texto (4.58:1
   sobre branco, ACCESSIBILITY §1.4). É o mesmo par do `PartnerCheckInMarker`
   no card de listagem, para o estado ser reconhecível nas duas telas.

   Preenchido, não contornado, e sem sombra: superfície apoiada dentro do card
   branco (§2 Depth Strategy). O ícone é sólido — `PartnerCheckInMarker` usa o
   mesmo ícone em `stroke` quando o check-in ainda não foi feito, e a diferença
   entre os dois estados é de preenchimento, não de existência
   (ACCESSIBILITY §1.6). */
export const PartnerCheckInDone = () => (
  <div
    role="status"
    className="flex h-[var(--control-h-lg)] w-full items-center justify-center gap-2 rounded-[var(--control-r-lg)] bg-[var(--color-success-light)] px-[var(--btn-px-lg)] text-[var(--color-success-text)]"
  >
    <CheckmarkCircle03Icon size={20} variant="solid" aria-hidden />
    <span className="text-base font-bold leading-none">Check-in feito</span>
  </div>
)
